export interface RtTitlesStateModel {
  currentTitle: string;
}

export const RT_TITLES_STATE_DEFAULT: RtTitlesStateModel = {
  currentTitle: '',
}
